import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function deleteImprovementProposalMeeting(meetingId) {
  if (!meetingId) return false;
  try {
    await getAPIResponse(`/v1/improvement-proposal/meeting/${meetingId}`, {}, 'DELETE');
    return true;
  } catch (e) {
    return false;
  }
}
